<template>
    <div>
        <CardBase>
            <MacroSubHeader
                title="Notificações"
                icon="el-icon-news"
            >
                <template slot="actions">
                    <el-button
                        size="small" 
                        type="primary"
                        @click="openModal"
                    >
                        <i class="fa fa-plus"></i>
                        Adicionar
                    </el-button>
                </template>
            </MacroSubHeader>

            <CardBase>
                <NotificacaoList ref="notificationList"/>
            </CardBase>
        </CardBase>

        <!-- NotificacaoCreate -->
        <NotificacaoCreateModal ref="notificationCreateModal" @created="handleDispatch"/>
    </div>
</template>
<script>    
    //Components
    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";

    import NotificacaoList from "@/components/_macro/notificacao/NotificacaoList.vue";
    import NotificacaoCreateModal from "@/components/_macro/notificacao/NotificacaoCreateModal.vue";

    export default {
        name: "notificacao-index",
        data() {
            return {}
        },
        methods: {
            openModal() {
                this.$refs.notificationCreateModal.toggleModal();
            },
            async handleDispatch() {
                await this.$refs.notificationList.fetch();
            },
        },
        components: {
            CardBase,
            MacroSubHeader,
            NotificacaoList,
            NotificacaoCreateModal,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/configuracoes/notificacao/Index.vue